import { request as executeRequest } from "@faire/web-api";
import { PrefetchRequestOptions } from "@faire/web/common/requests/prefetch";
import { useQuery } from "@tanstack/react-query";
import isArray from "lodash/isArray";

import { GREENHOUSE_API_BASE_URL, IDepartment } from "./greenhouseApi";

const EMPLOYMENT_URL = "/v1/boards/faire/departments";
const CONSULTANT_URL = "/v1/boards/faireconsultants/departments";

export enum WorkType {
  EMPLOYMENT = "EMPLOYMENT",
  CONSULTANT = "CONSULTANT",
}

const URL_WORK_TYPE_MAP = {
  [WorkType.EMPLOYMENT]: EMPLOYMENT_URL,
  [WorkType.CONSULTANT]: CONSULTANT_URL,
};

export const build = (workType: WorkType): PrefetchRequestOptions => {
  return {
    url: URL_WORK_TYPE_MAP[workType],
    route: URL_WORK_TYPE_MAP[workType],
    baseUrl: GREENHOUSE_API_BASE_URL,
    method: "GET",
    withCredentials: false,
  };
};

const getDepartments = async (workType: WorkType): Promise<IDepartment[]> => {
  const response = await executeRequest<{
    departments: IDepartment[];
  }>(build(workType));
  if (!isArray(response.departments)) {
    throw new Error("INVALID_RESPONSE");
  }
  return response.departments;
};

export const useGreenhouseQuery = (workType: WorkType) =>
  useQuery({
    queryKey: [`${workType}-departments`],
    queryFn: () => getDepartments(workType),
  });
